import $ from 'cash-dom';

/**
 * This module reveals the klaro consent layer
 */
export class KlaroModule {

    static name = 'klaro';

    constructor(node) {
        $('a[href="#klaro-consent"]').on('click', function() {
            klaro.show(undefined, false);
            return false;
        });
    }
}
